import { render, staticRenderFns } from "./updown-input.vue?vue&type=template&id=e799a51a&scoped=true&"
import script from "./updown-input.vue?vue&type=script&lang=ts&"
export * from "./updown-input.vue?vue&type=script&lang=ts&"
import style0 from "./updown-input.vue?vue&type=style&index=0&id=e799a51a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e799a51a",
  null
  
)

export default component.exports